import { AppointmentFormInputs } from "../interfaces/AppointmentFormInputs";

export const appointmentEmpty: AppointmentFormInputs = {
  cabin: "",
  date: "",
  hours: { id: 0, date: "", startHour: "", endHour: "" },
  doctorId: 0,
};
